import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { Button, Typography } from '@blade/ui-kit'
import { WalletModelShort } from '@root/entities/wallet/ui'
import { useAppRoutes } from '@root/features/routing'
import { useClipboard } from '@root/shared'
import { ArrowLeftIcon, CopyIcon, Truncate } from '@root/shared/ui-kit'

import type { WalletModel } from '@root/entities/wallet/atoms'

type Props = {
  wallet: WalletModel
}
export const WalletScreenHeader: React.FC<Props> = ({ wallet }) => {
  const { t } = useTranslation()
  const { navigateToWalletManager } = useAppRoutes()
  const { copyToClipboard } = useClipboard()

  const handleCopy = () => {
    copyToClipboard(wallet.address, {
      snackbarText: t('wallet.address_copied_snackbar'),
    })
  }

  return (
    <Root>
      <BackBtn
        onClick={() => {
          navigateToWalletManager()
        }}
        iconLeft={<ArrowLeftIcon />}
        variant="secondary"
        size={'h32'}
      />
      <WalletInfo>
        <Name size="md" wallet={wallet} />
        <AddressBox type="button" onClick={handleCopy}>
          <Address>
            <Truncate start={10} end={10}>
              {wallet.address}
            </Truncate>
          </Address>
          <CopyBtn>
            <CopyIcon size={16} />
          </CopyBtn>
        </AddressBox>
      </WalletInfo>
    </Root>
  )
}

const Root = styled.div`
  padding-inline: 12px;
  padding-block: 10px 16px;

  display: grid;
  grid-template-columns: auto minmax(0, 1fr) 32px;
`
const BackBtn = styled(Button)`
  align-self: end;
`

const Name = styled(WalletModelShort)`
  justify-self: center;
`

const AddressBox = styled.button`
  all: unset;
  display: flex;
  cursor: pointer;
  gap: 6px;
  align-items: center;
  color: var(--text-8);
`

const Address = styled(Typography).attrs({
  variant: 'body4-medium',
  component: 'div',
})``

const CopyBtn = styled.div`
  display: flex;
`

const WalletInfo = styled.div`
  display: grid;
  align-content: center;
  justify-content: center;
  gap: 4px;
`
